import React, { useState, useRef, useEffect } from 'react';
import { useCtx, useRecurso, useAccion, api } from '../estado.jsx';
import { Recurso } from './Comunes.jsx';
import { Fotos } from './Fotos.jsx';
import { clp } from '../utiles/fechas.js';

export function MiSedeView() {
  const { sedeId } = useCtx();
  const sede = useRecurso(() => api.sede(sedeId), [sedeId]);
  return (
    <div className="view on">
      <Recurso estado={sede} que="tu sede">{(s) => <Contenido sede={s} />}</Recurso>
    </div>
  );
}

function Contenido({ sede }) {
  const { openModal } = useCtx();
  const { ejecutar, enCurso, error, errorDatos } = useAccion();
  const [guardado, setGuardado] = useState('');

  useEffect(() => {
    if (errorDatos?.reservasFuera) openModal({ tipo: 'bloqueo', datos: errorDatos });
  }, [errorDatos, openModal]);
  const [ap, setAp] = useState(sede.hora_apertura?.slice(0, 5) || '09:00');
  const [ci, setCi] = useState(sede.hora_cierre?.slice(0, 5) || '19:00');
  const [bloque, setBloque] = useState(sede.bloque_min || 20);
  const [desc, setDesc] = useState(sede.descripcion || '');

  const guardar = () => ejecutar(
    () => api.editarMiSede({
      horaApertura: ap, horaCierre: ci,
      bloqueMin: parseInt(bloque, 10) || 20, descripcion: desc,
    }),
    () => { setGuardado('Guardado ✓'); setTimeout(() => setGuardado(''), 1800); },
  );

  const dato = (k, v) => (
    <div className="lrow"><span className="lk">{k}</span><span className="lv">{v}</span></div>
  );

  return (
    <>
      <div className="h-eyebrow">{sede.comuna} · Mi sede</div>
      <h1 className="h-title">Gestión de <em>{sede.comuna}</em></h1>
      <p className="h-sub">Edita tu operación, gestiona tus equipos, fotos y ofertas.</p>

      <h2 className="section-h">Datos de la sede</h2>
      <div className="frow" style={{ maxWidth: 520 }}>
        <div className="field"><label>Horario de atención</label>
          <div className="time-pair">
            <input className="inp" type="time" value={ap} onChange={(e) => setAp(e.target.value)} />
            <span>a</span>
            <input className="inp" type="time" value={ci} onChange={(e) => setCi(e.target.value)} />
          </div></div>
        <div className="field"><label>Bloque (min)</label>
          <input className="inp" type="number" min="5" step="5" value={bloque}
                 onChange={(e) => setBloque(e.target.value)} /></div>
      </div>
      <div className="field" style={{ maxWidth: 640 }}><label>Descripción del local</label>
        <textarea className="ta" value={desc} onChange={(e) => setDesc(e.target.value)}
                  placeholder="Ambiente, cómo llegar…" /></div>
      <button className="btn" onClick={guardar} disabled={enCurso}>
        {enCurso ? 'Guardando…' : 'Guardar datos'}
      </button>
      <span className="saved">{guardado}</span>
      <div className="inline-err show">{errorDatos?.reservasFuera ? '' : error}</div>

      <Equipos equipos={sede.tunes || []} />

      <h2 className="section-h">Gestionado por Aleph</h2>
      <p className="section-note">Solo lectura. Para cambiar cualquiera de estos, contacta con Aleph.</p>
      <div className="locked-panel">
        {dato('Nombre', sede.nombre)}
        {dato('Dirección', sede.direccion)}
        {dato('Precio sesión TUNE', clp(sede.precio_tune))}
        {dato('Equipos TUNE', (sede.tunes || []).length + ' unidades')}
      </div>

      <Fotos fotos={sede.fotos || []} />
      <Servicios servicios={sede.servicios || []} />
      <Bonos bonos={sede.bonos || []} />
    </>
  );
}

function Equipos({ equipos }) {
  const { ejecutar, enCurso } = useAccion();
  const [aviso, setAviso] = useState(null);

  return (
    <>
      <h2 className="section-h">Equipos TUNE</h2>
      <p className="section-note">
        Cambia el estado de tus equipos y la agenda se ajusta sola.{' '}
        <b>Aleph da de alta o retira equipos</b>; tú solo los pones en mantenimiento o los reactivas.
        Al parar un equipo, sus reservas se pasan a otro que esté libre a esa misma hora.
      </p>
      <div>{equipos.map((t) => {
        const enMant = t.estado === 'mantenimiento';
        return (
          <div key={t.id} className="equipo">
            <div className="eq-name">{t.etiqueta}</div>
            <div className="eq-r">
              <span className={'eq-state ' + (enMant ? 'mant' : 'ok')}>
                {enMant ? 'En mantenimiento' : 'Disponible'}
              </span>
              <button className="eq-btn" disabled={enCurso}
                      onClick={() => ejecutar(
                        () => api.cambiarTune(t.id, enMant ? 'disponible' : 'mantenimiento'),
                        (salida) => setAviso(enMant ? null : { equipo: t.etiqueta, ...salida }))}>
                {enMant ? 'Reactivar' : 'Poner en mantenimiento'}
              </button>
            </div>
          </div>
        );
      })}</div>

      {aviso ? <AvisoMantenimiento aviso={aviso} alCerrar={() => setAviso(null)} /> : null}
    </>
  );
}

/**
 * Qué ha pasado con las reservas del equipo que se acaba de parar.
 *
 * Las que no se han podido reubicar llevan el teléfono a la vista: son
 * llamadas que hay que hacer ahora, no información de consulta.
 */
function AvisoMantenimiento({ aviso, alCerrar }) {
  const { reubicadas = [], sinHueco = [] } = aviso;
  const nada = reubicadas.length === 0 && sinHueco.length === 0;

  return (
    <div className="card" style={{
      marginTop: 18, padding: 20, maxWidth: 560,
      borderLeft: `3px solid ${sinHueco.length ? 'var(--err)' : 'var(--pos)'}`,
    }}>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>
        {aviso.equipo} en mantenimiento
      </div>

      {nada ? (
        <div className="section-note" style={{ margin: 0 }}>No tenía reservas pendientes.</div>
      ) : null}

      {reubicadas.length ? (
        <>
          <div className="section-note" style={{ marginTop: 0 }}>
            {reubicadas.length} reserva{reubicadas.length === 1 ? '' : 's'} pasada
            {reubicadas.length === 1 ? '' : 's'} a otro equipo, sin avisar a nadie:
          </div>
          <ul style={{ margin: '6px 0 14px 18px', fontSize: 14 }}>
            {reubicadas.map((r, i) => (
              <li key={i}>{r.fecha} · {r.hora} · {r.cliente} → {r.equipo}</li>
            ))}
          </ul>
        </>
      ) : null}

      {sinHueco.length ? (
        <>
          <div className="inline-err show" style={{ marginTop: 0 }}>
            <b>{sinHueco.length} sin equipo libre.</b> Hay que llamar a estas personas:
          </div>
          <ul style={{ margin: '6px 0 0 18px', fontSize: 14 }}>
            {sinHueco.map((r, i) => (
              <li key={i}>{r.fecha} · {r.hora} · <b>{r.cliente}</b> · {r.telefono}</li>
            ))}
          </ul>
        </>
      ) : null}

      <button className="btn ghost" style={{ marginTop: 16 }} onClick={alCerrar}>Entendido</button>
    </div>
  );
}

function Servicios({ servicios }) {
  const { ejecutar, enCurso, error, setError } = useAccion();
  const [nombre, setNombre] = useState('');
  const [precio, setPrecio] = useState('');
  const [descripcion, setDescripcion] = useState('');

  const añadir = () => {
    const p = parseInt(precio, 10);
    if (!nombre.trim()) { setError('Ponle un nombre.'); return; }
    if (isNaN(p) || p < 0) { setError('Precio no válido.'); return; }
    ejecutar(
      () => api.añadirServicio({ nombre: nombre.trim(), precio: p, descripcion: descripcion.trim() || undefined }),
      () => { setNombre(''); setPrecio(''); setDescripcion(''); },
    );
  };

  return (
    <>
      <h2 className="section-h">Servicios</h2>
      <p className="section-note">
        Extras que presentas encima de la sesión TUNE (el precio TUNE es fijo). Ej. <b>Masaje + TUNE</b>.
      </p>
      <div className="oferta-form">
        <div className="field" style={{ margin: 0 }}><label>Nombre</label>
          <input className="inp" value={nombre} onChange={(e) => setNombre(e.target.value)}
                 placeholder="Masaje + TUNE" /></div>
        <div className="field" style={{ margin: 0 }}><label>Precio (CLP)</label>
          <input className="inp" type="number" min="0" step="500" value={precio}
                 onChange={(e) => setPrecio(e.target.value)} placeholder="38000" /></div>
        <button className="btn" onClick={añadir} disabled={enCurso}>Añadir</button>
        <div className="field full" style={{ margin: 0 }}><label>Descripción</label>
          <input className="inp" value={descripcion} onChange={(e) => setDescripcion(e.target.value)}
                 placeholder="Qué incluye" /></div>
      </div>
      <div className="inline-err show">{error}</div>
      <div>{servicios.length === 0
        ? <div className="empty-line">Aún no has añadido servicios.</div>
        : servicios.map((o) => (
          <div key={o.id} className="oferta">
            <div><div className="of-n">{o.nombre}</div>
              {o.descripcion ? <div className="of-d">{o.descripcion}</div> : null}</div>
            <div className="of-p"><div className="amt">{clp(o.precio)}</div>
              <button className="rm" disabled={enCurso}
                      onClick={() => ejecutar(() => api.quitarServicio(o.id))}>Quitar</button></div>
          </div>
        ))}</div>
    </>
  );
}

function Bonos({ bonos }) {
  const { ejecutar, enCurso, error, setError } = useAccion();
  const [nombre, setNombre] = useState('');
  const [sesiones, setSesiones] = useState('');
  const [precio, setPrecio] = useState('');
  const [vigencia, setVigencia] = useState('');

  const crear = () => {
    const ses = parseInt(sesiones, 10);
    const p = parseInt(precio, 10);
    const v = parseInt(vigencia, 10);
    if (!nombre.trim()) { setError('Ponle un nombre.'); return; }
    if (isNaN(ses) || ses < 1) { setError('Indica las sesiones.'); return; }
    if (isNaN(p) || p < 0) { setError('Precio no válido.'); return; }
    ejecutar(
      () => api.añadirBono({
        nombre: nombre.trim(), sesiones: ses, precio: p,
        vigenciaMeses: isNaN(v) ? undefined : v,
      }),
      () => { setNombre(''); setSesiones(''); setPrecio(''); setVigencia(''); },
    );
  };

  return (
    <>
      <h2 className="section-h">Bonos</h2>
      <p className="section-note">
        Paquetes de sesiones prepagadas. Un bono es distinto de un servicio: tiene{' '}
        <b>nº de sesiones</b> y <b>vigencia</b>.
      </p>
      <div className="oferta-form bono-form">
        <div className="field" style={{ margin: 0 }}><label>Nombre del bono</label>
          <input className="inp" value={nombre} onChange={(e) => setNombre(e.target.value)}
                 placeholder="Bono 10 sesiones" /></div>
        <div className="field" style={{ margin: 0 }}><label>Nº de sesiones</label>
          <input className="inp" type="number" min="1" step="1" value={sesiones}
                 onChange={(e) => setSesiones(e.target.value)} placeholder="10" /></div>
        <div className="field" style={{ margin: 0 }}><label>Precio (CLP)</label>
          <input className="inp" type="number" min="0" step="1000" value={precio}
                 onChange={(e) => setPrecio(e.target.value)} placeholder="250000" /></div>
        <div className="field" style={{ margin: 0 }}><label>Vigencia (meses)</label>
          <input className="inp" type="number" min="1" step="1" value={vigencia}
                 onChange={(e) => setVigencia(e.target.value)} placeholder="3" /></div>
        <button className="btn" onClick={crear} disabled={enCurso}>Crear bono</button>
      </div>
      <div className="inline-err show">{error}</div>
      <div>{bonos.length === 0
        ? <div className="empty-line">Aún no has creado bonos.</div>
        : bonos.map((b) => (
          <div key={b.id} className="oferta">
            <div>
              <div className="of-n">{b.nombre} <span className="bono-tag">Bono</span></div>
              <div className="of-d">
                {b.sesiones} sesiones
                {b.vigencia_meses
                  ? ` · vigencia ${b.vigencia_meses} mes${b.vigencia_meses === 1 ? '' : 'es'}`
                  : ''}
              </div>
            </div>
            <div className="of-p"><div className="amt">{clp(b.precio)}</div>
              <button className="rm" disabled={enCurso}
                      onClick={() => ejecutar(() => api.quitarBono(b.id))}>Quitar</button></div>
          </div>
        ))}</div>
    </>
  );
}
